"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("../styles"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _tokens = require("../styles/tokens");

var _excluded = ["children", "classes"];

var styles = function styles(theme) {
  return {
    root: {
      padding: _tokens.spacing20
    }
  };
};
/**
 * DialogContent is the main content that lives within a Dialog.
 */


var DialogContent = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
      classesProp = props.classes,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classes = {
    root: classesProp.root
  };
  return /*#__PURE__*/_react.default.createElement(_DialogContent.default, (0, _extends2.default)({
    classes: classes
  }, rest, {
    ref: ref
  }), children);
});

DialogContent.muiName = 'DialogContent';
DialogContent.displayName = 'DialogContent';
DialogContent.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,

  /**
   * @ignore
   */
  className: _propTypes.default.string
};

var _default = (0, _styles.default)(styles)(DialogContent);

exports.default = _default;